module.exports = __webpack_public_path__ + "img/correct.e400b658.png";